import React from 'react';
import axios from 'axios';

const NotificationsCountContext = React.createContext(null);

export const NotificationsProvider = ({ children }) => {
    const [countOfUnreadNotifications, setCountOfUnreadNotifications] = React.useState(0);
    const [loading, setLoading] = React.useState(true);

    const fetchUnreadNotifications = React.useCallback(() => {
        const token = localStorage.getItem('token');
        if (!token) return;

        axios.get('/api/get-count-unread-notifications', {
            headers: { Authorization: `Bearer ${token}` }
        })
        .then((response) => {
            setCountOfUnreadNotifications(response.data[0].count);
        })
        .catch((error) => {
            console.error('Ошибка при получении количества непрочитанных уведомлений:', error);
        })
        .finally(() => {
            setLoading(false)
        });
    }, []);

    React.useEffect(() => {
        fetchUnreadNotifications();
        const intervalId = setInterval(fetchUnreadNotifications, 2 * 60 * 1000);
        return () => clearInterval(intervalId);
    }, [fetchUnreadNotifications]);

    // Позволяем уменьшать счётчик локально, не дожидаясь следующего фетча
    const decrementCount = React.useCallback((by = 1) => {
        setCountOfUnreadNotifications((prev) => Math.max(0, prev - by));
    }, []);

    const markAllAsRead = React.useCallback(() => {
        setCountOfUnreadNotifications(0);
    }, []);

    return (
        <NotificationsCountContext.Provider
            value={{ countOfUnreadNotifications, loading, decrementCount, markAllAsRead, refetch: fetchUnreadNotifications }}
        >
            {children}
        </NotificationsCountContext.Provider>
    );
};

export const useNotifications = () => React.useContext(NotificationsCountContext);